// @core/api/endpoints/product/set_product_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductResponse,
  SetProductStatusRequest,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Set product status
 * Changes the product's lifecycle status. Products can be active, deprecated, or suspended with an optional reason message.
 */
export async function SetProductStatus(
  product_id: string,
  data: SetProductStatusRequest,
  options?: RequestOptions
): Promise<ProductResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/status`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.post<ProductResponse>(requestPath, data, requestOptions);
}
